import { createReducer, createAction } from 'redux-act';
import toast from 'shared/utils/toast';

import {
  fetchData,
  createData,
  deleteDataById,
  updateDataById
} from 'services/integratedShipping/integratedWarehouseWaveSetup';

const initialState = {
  isFetching: false,
  data: [],
  meta: {},
  isUpdate: false,
  error: false,
  message: ''
};

const fetchDataActionStart = createAction(
  'start fetch integrated warehouse wave list'
);
const fetchDataActionSuccess = createAction(
  'fetch integrated warehouse wave list success'
);
const fetchDataActionError = createAction(
  'fetch integrated warehouse wave list error'
);

const createUpdateDataActionStart = createAction(
  'start create/update integrated warehouse wave'
);
const createUpdateDataActionSuccess = createAction(
  'create/update integrated warehouse wave success'
);
const createUpdateDataActionError = createAction(
  'create/update integrated warehouse wave error'
);

export default createReducer(
  {
    [fetchDataActionStart]: (state) => ({
      ...state,
      isFetching: true
    }),
    [fetchDataActionSuccess]: (state, payload) => ({
      ...state,
      isFetching: false,
      data: payload.data,
      meta: payload.meta
    }),
    [fetchDataActionError]: (state) => ({
      ...state,
      isFetching: false,
      error: true,
      message: 'Have some errors while fetch data'
    }),
    [createUpdateDataActionStart]: (state) => ({
      ...state,
      isUpdate: true
    }),
    [createUpdateDataActionSuccess]: (state) => ({
      ...state,
      isUpdate: false
    }),
    [createUpdateDataActionError]: (state) => ({
      ...state,
      isUpdate: false
    })
  },
  initialState
);

export const fetchIntegratedWHWaveListAction = (companyId, param) => {
  return async (dispatch) => {
    try {
      dispatch(fetchDataActionStart());
      const res = await fetchData(companyId, param);
      dispatch(fetchDataActionSuccess({ data: res.data, meta: res.meta }));
    } catch (e) {
      dispatch(fetchDataActionError());
    }
  };
};

export const createIntegratedWHWaveAction = (companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await createData(companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSuccess());
        toast.success('Integrated Warehouse Wave Set-up has been created');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error(
        'Error occurred when creating Integrated Warehouse Wave Set-up'
      );
    }
  };
};

export const updateIntegratedShippingKPISetupAction = (id, companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await updateDataById(id, companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSuccess());
        toast.success('Integrated Warehouse Wave Set-up has been updated');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error(
        'Error occurred when updating Integrated Warehouse Wave Set-up'
      );
    }
  };
};

export const deleteIntegratedShippingKPISetupAction = (id) => {
  return async (dispatch) => {
    try {
      const res = await deleteDataById(id);
      if (res) {
        dispatch(createUpdateDataActionSuccess());
        toast.success('Integrated Warehouse Wave Set-up has been deleted');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error(
        'Error occurred when deleting Integrated Warehouse Wave Set-up'
      );
    }
  };
};
